import { FocusTrapZone, Layer, Overlay } from '@fluentui/react';
import { RequestDetailsPopUpStyle } from '../styles/RequestDetailsPopUp.styled';
import { useCancelRequest } from '../hooks/useCancelRequest';
import { RequestDetailsCancelPopupContainer } from './RequestDetailsCancelPopupContainer';
import { VacationRequestType } from '../../../../../tabs/hooks/useSummaryInfo';
import { VacationsRequest } from '../models/RequestDetails.interface';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';

interface RequestDetailsCancelPopupProps {
  isCancelPopupVisible: boolean;
  hideCancelPopup: () => void;
  hideRequestPopup: () => void;
  requestId: string;
  requestDetails: VacationsRequest;
  vacationTypes: VacationType[];
  getSummary: (
    bonusDays?: number,
    paidDays?: number,
    requestType?: VacationRequestType
  ) => Promise<void>;
  getUserRequests: (
    statusCode?: string[],
    vacationTypeId?: string[],
    vacationTypes?: VacationType[]
  ) => Promise<void>;
  vacationType: string[];
  vacationStatus: string[];
}

export const RequestDetailsCancelPopup = ({
  hideCancelPopup,
  isCancelPopupVisible,
  hideRequestPopup,
  requestId,
  getSummary,
  requestDetails,
  vacationTypes,
  getUserRequests,
  vacationStatus,
  vacationType,
}: RequestDetailsCancelPopupProps) => {
  const { cancelRequest } = useCancelRequest(requestId);
  const cancelRequestHandler = async () => {
    await cancelRequest(
      getSummary,
      requestDetails?.new_numberofworkdays,
      requestDetails?._new_vacationtype_value_Formatted
    );
    await getUserRequests(vacationStatus, vacationType, vacationTypes);
    hideCancelPopup();
    hideRequestPopup();
  };
  return (
    <>
      {isCancelPopupVisible && (
        <Layer>
          <RequestDetailsPopUpStyle
            role="dialog"
            aria-modal="true"
            onDismiss={hideCancelPopup}
          >
            <FocusTrapZone>
              <Overlay onClick={hideCancelPopup} />
              <RequestDetailsCancelPopupContainer
                cancelRequestHandler={cancelRequestHandler}
                hideCancelPopup={hideCancelPopup}
              />
            </FocusTrapZone>
          </RequestDetailsPopUpStyle>
        </Layer>
      )}
    </>
  );
};
